import API from '../api';
import {
    sessionStatementExportPath,
    studentPortalBase,
    studentPortalOverviewPath,
    studentPortalWalletPath,
    studentPortalWalletReceiptPath,
    studentPortalWalletTopupInitiatePath,
    studentPortalWalletTopupVerifyPath,
    studentPortalWalletTopupCompletePath,
    studentPortalWalletAutopayPath,
    studentPortalWalletAutopaySetupPath,
    studentPortalWalletAutopayCompletePath,
    studentPortalWhatsAppPreferencesPath,
    studentPortalPlayingPath,
} from './paths/studentPortalPaths';

export { studentPortalBase } from './paths/studentPortalPaths';

export const fetchStudentOverview = (childStudentId, params) =>
  API.get(studentPortalOverviewPath(childStudentId), { params }).then((r) => r.data);

export const fetchStudentAttendanceReport = (childStudentId, config) =>
  API.get(`${studentPortalBase(childStudentId)}/attendanceReport`, config).then((r) => r.data);

export const fetchStudentSessions = (childStudentId, config) =>
  API.get(`${studentPortalBase(childStudentId)}/sessions`, config).then((r) => r.data);

export const fetchStudentCalendar = (childStudentId, from, to) =>
  API.get(`${studentPortalBase(childStudentId)}/sessions/calendar`, { params: { from, to } }).then((r) => r.data);

export const fetchStudentUpcoming = (childStudentId, days = 7) =>
  API.get(`${studentPortalBase(childStudentId)}/sessions/upcoming`, { params: { days } }).then((r) => r.data);

export const fetchStudentEnrollments = (childStudentId) =>
  API.get(`${studentPortalBase(childStudentId)}/enrollments`).then((r) => r.data);

export const fetchStudentWallet = (childStudentId) =>
  API.get(studentPortalWalletPath(childStudentId)).then((r) => r.data);

export const fetchSessionStatement = (childStudentId, { from, to }) =>
  API.get(`${studentPortalBase(childStudentId)}/reports/session-statement`, { params: { from, to } }).then((r) => r.data);

export const sessionStatementExportUrl = (childStudentId, range) =>
  sessionStatementExportPath(childStudentId, range);

export const initiateChildWalletTopup = (childStudentId, amount, gateway, options = {}) =>
  API.post(studentPortalWalletTopupInitiatePath(childStudentId), {
    amount,
    gateway,
    purpose: options.purpose,
    enrollmentId: options.enrollmentId,
  }).then((r) => r.data);

export const verifyChildWalletTopup = (childStudentId, payload) =>
  API.post(studentPortalWalletTopupVerifyPath(childStudentId), {
    gateway: 'GATEWAY_RAZORPAY',
    ...payload,
  }).then((r) => r.data);

export const completeChildWalletTopup = (childStudentId, gateway, externalId) =>
  API.post(studentPortalWalletTopupCompletePath(childStudentId), { gateway, externalId }).then((r) => r.data);

export const fetchChildAutopayStatus = (childStudentId) =>
  API.get(studentPortalWalletAutopayPath(childStudentId)).then((r) => r.data);

export const startChildAutopaySetup = (childStudentId) =>
  API.post(studentPortalWalletAutopaySetupPath(childStudentId)).then((r) => r.data);

export const completeChildAutopaySetup = (childStudentId, sessionId, paymentId) =>
  API.post(studentPortalWalletAutopayCompletePath(childStudentId), {
    sessionId,
    orderId: sessionId,
    paymentId,
  }).then((r) => r.data);

export const revokeChildAutopay = (childStudentId) =>
  API.delete(studentPortalWalletAutopayPath(childStudentId)).then((r) => r.data);

export const downloadChildWalletReceipt = async (childStudentId, txnId) => {
  const response = await API.get(studentPortalWalletReceiptPath(childStudentId, txnId), {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `receipt-TXN-${txnId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const fetchChildWhatsAppPreferences = (childStudentId) =>
  API.get(studentPortalWhatsAppPreferencesPath(childStudentId)).then((r) => r.data);

export const saveChildWhatsAppPreferences = (childStudentId, prefs) =>
  API.put(studentPortalWhatsAppPreferencesPath(childStudentId), prefs).then((r) => r.data);

export const fetchChildPlayingPeek = (childStudentId) =>
  API.get(studentPortalPlayingPath(childStudentId)).then((r) => r.data);
